import { useTasks } from 'app/agriculture/queries/tasks/useTasks';
import { useSelection } from 'app/agriculture/ContextMenu/hooks/useSelection/useSelection';
import { createBillboardIconDataUri } from 'app/agriculture/icons/utils/map-icon-utils/createBillboardIconDataUri';
import { CesiumBillboard } from 'app/agriculture/FarmMain/MapRenderer/components/CesiumBillboard';
import { createIcon } from 'app/agriculture/hooks/useMapRender/mapRenderUtils';
import { getTaskIconConfig } from 'app/agriculture/icons/utils/map-icon-utils/getTaskIconConfig';
import { isTaskOverdue } from 'app/agriculture/routes/Tasks/utils/isTaskOverdue';
import { useCurrentUser } from 'app/agriculture/hooks/users/useCurrentUser';

export function TaskRenderer() {
    const tasks = useTasks();
    const { isSelected } = useSelection();
    const currentUser = useCurrentUser();

    return (
        <>
            {Array.from(tasks).map(
                ([id, { location, isComplete, endDate, priority, assignees }]) => {
                    if (isComplete || !location) return null;

                    const { icon, options } = getTaskIconConfig({
                        priority,
                        overdue: isTaskOverdue({ isComplete, endDate }),
                        assignedToYou: assignees.some((id) => id === currentUser.id),
                    });

                    const image = createBillboardIconDataUri(icon, options);

                    return (
                        <CesiumBillboard
                            key={id}
                            billboardOptions={createIcon({
                                id,
                                coordinates: [location.longitude, location.latitude],
                                image,
                                isPin: options.billboardType === 'pin' || false,
                                isSelected: isSelected(id),
                            })}
                        />
                    );
                },
            )}
        </>
    );
}
